import { createContext, PropsWithChildren, useCallback, useContext, useState } from "react"
import PDFViewer, { PDFViewerProps } from "../../components/PDFViewer"

type FilePDF = {
    url: string,
    name: string
}

type PDFViewerContextData = {
    file?: FilePDF,
    setFile: (file?: FilePDF) => void,
    setConfig: (config: PDFViewerProps) => void,
}

const DEFAULT: PDFViewerContextData = {
    file: undefined,
    setFile: () => { },
    setConfig: () => { },
}

const PDFViewerContext = createContext(DEFAULT);

export const PDFViewerProvider = ({ children }: PropsWithChildren<any>) => {
    const [file, setFile] = useState<FilePDF>();
    const [configPDFViewer, setConfigPDFViewer] = useState<PDFViewerProps>();

    const changeFile = useCallback((file?: FilePDF) => {
        setFile(file);
    }, []);

    const setConfig = useCallback((config: PDFViewerProps) => {
        setConfigPDFViewer(config);
    }, []);

    return (
        <PDFViewerContext.Provider
            value={{
                file,
                setFile: changeFile,
                setConfig
            }}>
            {children}
            <PDFViewer {...configPDFViewer}></PDFViewer>
        </PDFViewerContext.Provider>
    );
}

export function usePDFViewer(): PDFViewerContextData {
    const context = useContext(PDFViewerContext);

    if (!context) {
        throw new Error('useAuth must be used within an AuthProvider');
    }

    return context;
}